module.exports = __webpack_public_path__ + "static/media/CharityScreen.d400931f.png";